import { TRIPS } from '@/constants/index';
import CONSTANTS from '@/helpers/constants';
import { plainObject } from '@/utils/plainObject';
import { ITrip } from '~/api/ITrip';
import { ITripLeg } from '~/api/ITripLeg';

export const updateLeg = (tripInfo: ITrip, leg: ITripLeg, legType: string): void => {
  const tripLegIndex = tripInfo.legs.findIndex((tripLeg) => tripLeg.type === legType);
  if (tripLegIndex === -1) {
    return;
  }
  const updatedLeg = { ...leg, type: legType };
  tripInfo.legs?.splice(tripLegIndex, 1, updatedLeg);
};

/**
 * Used to swap pick and drop off legs for the trip
 * @param {Object} trip to be swapped
 * @returns swapped legs trip
 */

export const swapLegs = (trip: ITrip): ITrip => {
  let tripInfo = <ITrip> {};

  if (Object.keys(trip).length > 0) {
    tripInfo = plainObject(trip);
    trip.legs?.forEach((leg) => {
      if (leg.type === TRIPS.CONTEXT.PICK_UP) {
        if (trip.tripType === CONSTANTS.TRIPS.ADD_TRIP_OPTIONS.RETURN_TRIP) {
          updateLeg(tripInfo, leg, TRIPS.CONTEXT.DROP_OFF);
        }
        else {
          updateLeg(tripInfo, <ITripLeg> {}, TRIPS.CONTEXT.DROP_OFF);
        }
      }
      else if (leg.type === TRIPS.CONTEXT.DROP_OFF) {
        updateLeg(tripInfo, leg, TRIPS.CONTEXT.PICK_UP);
      }
    });
  }

  return tripInfo;
};
